/* Prepare Barracuda funcitons set */
var Barracuda = {};

/* general functions */
function prevent(event) {
   if (event) event.preventDefault();
}

/* Show window dimensions in corner */
Barracuda.createStats = function (){
   var stats = document.querySelector(".stats");
   if(stats){
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      stats.innerHTML = "" + vw + " px<br>"+ vh +" px<br>"+ (scrollbarWidth>30? "<s>"+scrollbarWidth+"px</s>": scrollbarWidth + "px");
      
      if(document.querySelector(".overlay")){
      document.querySelector(".overlay").style.width = vw + "px";
      document.querySelector(".overlay").style.height = vh + "px";
      }
   }
}

/* Cookies functions */
function getCookie(cname) {
   let name = cname + "=";
   let decodedCookie = decodeURIComponent(document.cookie);
   let ca = decodedCookie.split(';');
   for(let i = 0; i <ca.length; i++) {
   let c = ca[i];
   while (c.charAt(0) == ' ') {
      c = c.substring(1);
   }
   if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
   }
   }
   return "";
}
function setCookie(cname, cvalue, exdays) {
   if(getCookie('cookie-bar') == "confirm" || cname == "cookie-bar"){
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
   }
}

/* overlay actions */
function overlayClick(event, force = false) {
   if (force || (event.target.classList && (event.target.classList.contains("overlay") || event.target.closest("a") && event.target.closest("a").classList.contains("overlay-closer"))) )
   {
      document.querySelector("body").classList.remove("show-overlay");
      setTimeout(function() {
         let overlayContent = document.querySelector(".overlay-content")
         overlayContent.innerHTML = "";
         overlayContent.classList.remove("popup-newsletter");
         if (overlayContent.dataset.lastPosition) {
            overlayContent.classList.remove(overlayContent.dataset.lastPosition);
            overlayContent.dataset.lastPosition = null;
         }
         overlayContent.classList.add("loading", "overlay-content");
      }, 500)
      unlockBodyPosition();
   }
}

/* Topbar actions */
function openTopbar(event, targetName){
   prevent(event);
   target = document.getElementById(targetName);
   if (target) { 
      document.querySelector("body").classList.add("topbar-open");
      target.removeAttribute("hidden");
      setTimeout(function () {
         target.classList.add("control-visible");
         let animeOpenTopbar = anime.timeline({
         }).add({
            targets: target,
            duration: 500,
            top: 0,
            easing: 'easeOutQuart',
            complete: function () {target.classList.add("visible");}
         }).add({
            targets: target,
            opacity: 1,
            duration: 200
         }, 0).add({
            targets: target.querySelectorAll(".main-menu>ul>li,.main-menu>form,#localization_form>div,.social-banner"),
            translateY: [-50, 0],
            opacity: [0, 1],
            duration: 525,
            easing: 'easeOutQuart',
            delay: anime.stagger(15, {start: 0})
         },250)
         lockBodyPosition();
         var focusTarget = target.querySelector(".topbar-focus");
         if(focusTarget){ 
            focusTarget.focus();
         }
      },50)
   }
}
function closeTopbar(event) {
   prevent(event);
   let animeCloseTopbar = anime.timeline({
      targets: ".topbar.visible"
   }).add({
      duration: 500,
      top: "-100vh",
      easing: 'easeInQuad',
      complete: function () {
         document.querySelectorAll(".topbar.visible").forEach((el) => {
            el.classList.remove("visible"); el.classList.remove("control-visible");
         })
         document.querySelector("body").classList.remove("topbar-open");
      }
   }).add({
      duration: 10,
      opacity: 0
   })
   
   if(document.querySelector(".topbar #auth-form"))
      Barracuda.loadPageFromCode("auth-form","login-form",document.querySelector(".topbar #auth-form").dataset.baseURL)
   unlockBodyPosition();
}

/* Functions for blocking scroll when overlay is visible */
function noScroll(event) { 
   var inside = event.target.closest(".scroll-inside");
   if(inside && event.deltaY){
      if(event.deltaY > 0 && inside.scrollTop + inside.offsetHeight < inside.scrollHeight){
      }else if(event.deltaY < 0 && inside.scrollTop > 0){
      }else{
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();}
   }
}
function noScrollTouchMove(event) {
   var inside = event.target.closest(".scroll-inside");
   if(inside){
      var noScrollTouchEnd = event.changedTouches[0].clientY;
      if (noScrollTouchStartClientY > noScrollTouchEnd && inside.scrollTop + inside.offsetHeight < inside.scrollHeight) {
      } else if ((noScrollTouchStartClientY < noScrollTouchEnd) && inside.scrollTop > 0) {
      }else{
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();}
   }
}
function noScrollTouchStart(event){
   noScrollTouchStartClientY = event.touches[0].clientY
}

var bodyPostionY = null;
var noScrollTouchStartClientY = null;
/* lock body scroll */
function lockBodyPosition() {
      Barracuda.setScrollBarWidth();
   document.querySelector("body").classList.add("no-scroll");
      // add listener to disable scroll
      document.querySelectorAll(".scroll-inside").forEach(el=>{
         el.addEventListener('mousewheel', noScroll, {passive: true});
         el.addEventListener('touchstart', noScrollTouchStart, {passive: true});
         el.addEventListener('touchmove', noScrollTouchMove, {passive: true});
      });
}
function unlockBodyPosition() {
   document.querySelector("body").classList.remove("no-scroll");
   window.removeEventListener('mousewheel', noScroll,{passive: true});
   window.removeEventListener('touchstart', noScrollTouchStart,{passive: true});
   window.removeEventListener('touchmove', noScrollTouchMove,{passive: true});

}

/* menu actions */
function openSubmenu(event){
   prevent(event);
   var parentLi = event.target.closest("li");
   var height = parentLi.querySelector("ul").style.maxHeight

   parentLi.classList.toggle("open");
   if(height == "") parentLi.querySelector("ul").style.maxHeight = parentLi.querySelector("ul").scrollHeight + "px";
   else parentLi.querySelector("ul").style.maxHeight = "";

   var parentUl = event.target.closest("ul");
   if(parentUl.classList.contains("child")) parentUl.style.maxHeight = (parentUl.scrollHeight + parentLi.querySelector("ul").scrollHeight) + "px";
   
}

/* Fade functions */
Barracuda.duration = 300;
Barracuda.fadeOut = function(el, after = null, time = Barracuda.duration) {
   if(!el.dataset.animated || el.dataset.animated == "false"){
      el.dataset.animated = true;
      el.style.opacity = 1;
      (function fadeOutTemp(){
            el.style.opacity = parseFloat(el.style.opacity) - .02
         if ((el.style.opacity)<0){
            el.classList.add("hide");
            el.dataset.animated = false;
            el.style.opacity = 0;
            if(after) after();}
         else {
            setTimeout(fadeOutTemp,(time / 50))
         }
      })();
   }
};

Barracuda.fadeIn = function(el, after = null, time = Barracuda.duration) {
   if(!el.dataset.animated || el.dataset.animated == "false"){
      el.dataset.animated = true;
      el.style.opacity = 0;
      el.classList.remove("hide");
      (function fadeInTemp(){
            el.style.opacity = parseFloat(el.style.opacity) + .02
         if ((el.style.opacity)>1){
            el.dataset.animated = false;
            el.style.opacity = 1;
            if(after) after();}
         else {
            setTimeout(fadeInTemp,(time / 50))
         }
      })();
   }
}

/* Define methods for dynamic loaded sections */
Barracuda.loadSection = function(){
   document.querySelectorAll(".load-section:not(.initialized)").forEach(el=>{
      el.classList.add("initialized");
      el.addEventListener("click",(e)=>{
         prevent(e);
         var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
         if(currentContent && currentContent.dataset.source){
            var t = document.querySelector("#"+currentContent.dataset.source);
            if(t) t.appendChild(currentContent);
         }

         var targetElement = el.dataset.target? (document.querySelector("#"+el.dataset.target)? document.querySelector("#"+el.dataset.target): false) : false

         if(!targetElement){
            document.querySelector(".overlay-content").innerHTML = "";
            document.querySelector(".overlay-content").classList.add("loading")
            lockBodyPosition();
         }

         var url =  window.location.href;
         if(el.dataset.url){
            var url = el.dataset.url;
         } 
         if((!el.dataset.url && el.closest("form") )|| el.dataset.useform){
            var url = url.split("#")
            var url = url[0] + (url[0].includes("?") ? "&" : "?") + new URLSearchParams(Array.from(new FormData(el.closest("form"))));
         }

         var url = url.split("#")
         var url_section = url[0] + (url[0].includes("?") ? "&" : "?") + "sections=" + el.dataset.section;
         if(el.dataset.urlset)
         { 
            window.history.pushState('', '', url[0]);
         }
         /* console.log("LoadSection: " + url_section); */
         axios.get(url_section)
         .then(function (response) {
            var code = response.data? (response.data[el.dataset.section]? response.data[el.dataset.section] : false):false;
            if (code){
               code = code.replace(/__CURRENT_URL_WITH_APPEND__/g, url[0] + (url[0].includes("?") ? "&" : "?"));
               code = code.replace(/__CURRENT_URL__/g, url[0]);

               if(targetElement){
                  targetElement.classList.remove("loading")

                  if(targetElement.innerHTML!=""){
                     Barracuda.fadeOut(targetElement, (()=>{
                        if(el.dataset.part){
                           var candidate = document.createElement("div");
                           candidate.innerHTML = code;
                           code = candidate.querySelector("."+el.dataset.part);
                           targetElement.innerHTML = "";
                           targetElement.appendChild(code);
                        }else{
                           targetElement.innerHTML = code;
                        }
                        Barracuda.init();
                        Barracuda.elements.init();
                        
                        Barracuda.fadeIn(targetElement,Barracuda.setScrollBarWidth)
                     }).bind(this))
                  }else{
                     if(el.dataset.part){
                        var candidate = document.createElement("div");
                        candidate.innerHTML = code;
                        code = candidate.querySelector("."+el.dataset.part);
                        targetElement.innerHTML = "";
                        targetElement.appendChild(code);
                     }else{
                        targetElement.innerHTML = code;
                     }
                     Barracuda.init();
                     Barracuda.elements.init();
                     Barracuda.setScrollBarWidth();
                  }

               } else {
                  let content = document.querySelector(".overlay-content");
                  content.classList.remove("loading")
                  content.innerHTML = code;
                  lockBodyPosition();
                  document.querySelector("body").classList.add("show-overlay");
               }
                  Barracuda.init();
                  Barracuda.elements.init();
            } 
         })
         .catch(function (error) {
            if(!targetElement){
               document.querySelector(".overlay-content").classList.remove("loading")
            }
            console.warn(error);
         });
         return false;
      },false)
   });
}
Barracuda.loadPageFromCode = function (targetId, sourceId, url) {
   let targetElement = document.querySelector("#" + targetId);
   axios.get(url)
   .then(function (response) {
      if(response.data){
         var x = document.createElement("html");
         x.innerHTML = response.data;
         var source = x.querySelector("#"+ sourceId);
         if(source){
            targetElement.innerHTML = "";
            targetElement.appendChild(source);

            Barracuda.init();
            Barracuda.elements.init();
         }
         return false;
      }
      return false;
   })
   .catch(function (error) {
      console.error(error);
      return false;
   });
}
/* Dynamic load page - part page */
Barracuda.loadPage = function(){
   document.querySelectorAll(".load-page:not(.initialized)").forEach(el=>{
      el.classList.add("initialized");
      el.addEventListener("click",(e)=>{
         prevent(e);

         var targetElement = el.dataset.target? (document.querySelector("#"+el.dataset.target)? document.querySelector("#"+el.dataset.target): false) : false
         var sourceId = el.dataset.source? el.dataset.source : (el.dataset.target? el.dataset.target: false);
         var url = el.dataset.url? el.dataset.url : (el.href? el.href : false);
         url = (url.split("#"))[0];
         
         if(el.dataset.urlset && el.closest(".topbar")==null) window.history.pushState('', '', url);

         if(targetElement && sourceId && url){
            /* console.log("BarracudaLoadPage: urlset: "+el.dataset.urlset+", url: "+ url +", sourceId: #"+sourceId+", target:", targetElement) */
            targetElement.classList.add("loading");

            if(sourceId == "pagination"){
               /* console.log("BarracudaLoadPage: Pagination - scroll up ", targetElement.offsetTop) */
               if(targetElement.offsetTop - 200 < 200)
                  window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
               else
                  window.scrollTo({top: (targetElement.offsetTop - 200), left: 0, behavior: 'smooth'})

            }

            axios.get(url)
            .then(function (response) {
               if(response.data){
                  var x = document.createElement("html");
                  x.innerHTML = response.data;
                  var source = x.querySelector("#"+ sourceId);
                  if(source){
                     el.parentElement.querySelectorAll(".load-page.active").forEach(function (y){
                        y.classList.remove("active");
                     })
                     el.classList.add("active")
                     
                     Barracuda.fadeOut(targetElement, (()=>{
                        if(sourceId != "pagination"){
                           targetElement.innerHTML = "";
                           targetElement.appendChild(source);
                        }else{
                           source.classList.add("hide", "loading")
                           targetElement.replaceWith(source);
                           targetElement = source;
                        }
                        targetElement.classList.remove("loading")

                        Barracuda.init();
                        Barracuda.elements.init();

                        Barracuda.fadeIn(targetElement, Barracuda.setScrollBarWidth)
                     }).bind(this))
                  }
                  return false;
               }
               return false;
            })
            .catch(function (error) {
               console.error(error);
            });
         }
         return false;
      },false)
   });
}
/* Show template in overlay */
Barracuda.templateOverlay = function(){
   document.querySelectorAll(".template-overlay:not(.initialized)").forEach(el=>{
      el.classList.add("initialized");
      el.addEventListener("click", (e) => {
         console.log(111)
         prevent(e);
         var template = document.getElementById(el.dataset.source);
         let target = document.querySelector(".overlay-content");
         if(template){
            target.classList.add("loading");
            lockBodyPosition();
   
            var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
               
            if(currentContent && currentContent.dataset.source && document.querySelector("#"+currentContent.dataset.source))
               document.querySelector("#"+currentContent.dataset.source).appendChild(currentContent);

            target.innerHTML = "";

            var closer = document.createElement("a");
            closer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
            closer.classList.add("icon","icon-x","overlay-closer");
            
            var content = document.createElement("div");
            content.innerHTML = template.innerHTML;
            content.classList.add("overlay-content-content","quick-view","quick-view-form","scroll-inside");
            if (template.dataset.type) content.classList.add(...template.dataset.type.split(" "));
            
            target.appendChild(closer);
            target.appendChild(content);

            if(content.querySelector(".map")){
               setTimeout(function() { 
                  Barracuda.loadMapsScript(content);
               },200);
            }

            Barracuda.init();
            Barracuda.elements.init();
            target.classList.remove("loading");
            document.querySelector("body").classList.add("show-overlay");
         }
      })
   })
}
/* Define methods for dynamic collapse elements */
Barracuda.toggleCollapsible = function(e) {
   prevent(e);
   var opener = e.target.closest(".collapse-toggle")
   if(opener){
      var element = document.getElementById(opener.dataset.target);
      if(element.classList.contains("collapsed")){
         element.style.height = element.scrollHeight + "px";
         element.classList.remove("collapsed");
         setTimeout(()=>{
            element.style.height = "auto";
         }, 500);
         opener.classList.add("opened");
      }else{
         element.style.height = element.scrollHeight + "px";
         setTimeout(()=>{
            element.style.height = 0 + "px";
         },10);
         element.classList.add("collapsed");
         opener.classList.remove("opened");
      }
   }
}

/* Add event listeners for dynamic collapse elements */
Barracuda.initCollapsible = function(){
   document.querySelectorAll(".collapse-toggle:not(.collapse-toggle-initialized)").forEach(el => {
      el.addEventListener("click",Barracuda.toggleCollapsible);
      el.classList.add("collapse-toggle-initialized");
   })
}

/* Create autoresize textarea element */
Barracuda.textareaAutoresize = function(){
   document.querySelectorAll("textarea.autoresize:not(.autoresize-initialized)").forEach(el => {
      el.addEventListener("keyup",(e)=>{
         e.target.style.height = "0px";
         e.target.style.height = (e.target.scrollHeight - (el.dataset.correction? el.dataset.correction : 26)) + "px";
      })
      el.classList.add("autoresize-initialized");
   })
}

/* Close section and save it to cookies */
Barracuda.cookieSection = function(){
   document.querySelectorAll(".hide-by-cookie-section:not(.hide-by-cookie-section-initialized)").forEach((el)=>{
      var dataEl = el.querySelector(".hide-by-coookie-data");
      var respawn_time = el.dataset.respawn? parseInt(el.dataset.respawn) : parseInt(dataEl? (dataEl.dataset.respawn? dataEl.dataset.respawn : 0) : 0);
   
      el.classList.add("hide-by-cookie-section-initialized")
      if (getCookie('cookie-' + el.id + '-' + respawn_time) != "closed" || Shopify.designMode) {
         el.classList.remove("hide-by-cookie");
         el.querySelectorAll(".hide-by-cookie-toggle").forEach(toggle=>{
            toggle.addEventListener("click",()=>{
               if(el.querySelector(".badge-section")){
                  Barracuda.fadeOut(el.querySelector(".badge-section"),()=>{
                     el.classList.add("hide-by-cookies");
                  }, (Barracuda.duration * 2));
               }
               if(el.classList.contains("announcement-bar-content"))
               {    
                  document.documentElement.style.setProperty('--announcement-bar-height', 0 + "px");
                  el.style.height = parseInt(el.offsetHeight) + "px";
                  el.style.overflow = "hidden";
                  el.style.transition = "height 1s ease";
                  el.style.minHeight = "0px";
                  el.style.height = "0px";
                  setTimeout(function(){Barracuda.initAddHeight();
                  },1000)

               }
               /* console.log("Cookies - element: ", el, " repsawn_time: ", respawn_time) */
               // respawn_time is in days
               if(respawn_time > 0) setCookie('cookie-'+el.id+'-'+respawn_time,"closed",respawn_time);
            },false);
         })
      }
   })
}

Barracuda.loadMapsScript = function(content = null){
   if(!document.getElementById("ol-script")){
      var tag = document.createElement("script");
      tag.id = "ol-script"
      tag.src = document.querySelector(".ol-url")? document.querySelector(".ol-url").dataset.url : "";
      document.getElementsByTagName("head")[0].appendChild(tag);

      window.removeEventListener("scroll", Barracuda.elements.lazyMapsListener)
   }else{
      if(content)
         content.querySelectorAll(".map.map-initialized").forEach(element => {
            element.dispatchEvent(new Event('renderMap'))
         })
      document.querySelectorAll(".map:not(.map-initialized)").forEach(element => {
         new BarracudaMap(element)
      })
   }
}
Barracuda.checkMaps = function(){
   if(typeof BarracudaMap === "undefined"){
      Barracuda.elements.lazyMaps.forEach((element, index)=>{
         if(!document.getElementById("ol-script") && element.getBoundingClientRect().top <= (window.innerHeight + window.scrollY)){
            Barracuda.loadMapsScript();
            window.removeEventListener("scroll", Barracuda.checkMaps, {passive: true});
         }
      })
   }
}
Barracuda.checkVideos = function(){
   Barracuda.elements.lazyVideos.forEach((element, index)=>{
   if(element.getBoundingClientRect().top <= (window.innerHeight + window.scrollY)){
      element.src = element.dataset.src;
      var video = element.closest("video");
      if(video && video.play && video.autoplay ) video.play();

      Barracuda.elements.lazyVideos.splice(index, 1);
      if(Barracuda.elements.lazyVideos.length==0) 
         window.removeEventListener("scroll", Barracuda.elements.lazyVideosListener)
   }
   })
}

/* Function which adding spaces between sections with differents backgrounds */
Barracuda.sectionPaddingForBackgroundsTwo = function(ignoreSection = false){
var type = "";
var first = false;
if(ignoreSection){
      var sections = document.querySelectorAll("#page-content>.shopify-section:not(#shopify-section-header):not(#shopify-section-main-password-header):not(.out-of-structure):not(#"+ignoreSection.id+")");
}else{
   var sections = document.querySelectorAll("#page-content>.shopify-section:not(#shopify-section-header):not(#shopify-section-main-password-header):not(.out-of-structure)");
}
   sections.forEach((element, key, elements) => {

      var child = element.querySelector(".section-with-padding,.section-without-padding");

      if (!first && !element.classList.contains("out-of-structure")) {
         element.classList.add("first-of-content")
         let header = document.querySelector("#header");
         console.log("Offset, ", header, element, child);
         if (header && header.dataset.background && child && child.dataset.background && (child.dataset.background != header.dataset.background && child.dataset.background != "desktop-" + header.dataset.background) ) {
            document.documentElement.style.setProperty('--header-offset', 'min(5.8vw,47px)');
            console.log("offset set");
         }
         first = true;
      } else {
         element.classList.remove("first-of-content")
      }

      /*  console.log("First-of-type section: key: ",key," type-before:", type, " child:", child? child : "-", " child-type", child? child.dataset.background : "", " element:", element); */
      if (key == 0) {
         //first element
         element.classList.add("first-of-type")
         type = child ? child.dataset.background : "";
      } else {
         //if new component
         if (child && !element.classList.contains("out-of-structure")) {
            //if same type as previous
            if (child.dataset.background == type || type == "same") {
               element.classList.remove("first-of-type")
               element.classList.remove("first-of-type-on-desktop")
            } else if ("desktop-" + child.dataset.background == type || type == "mobile-same") {
               // if same background on mobile, but not on desktop
               element.classList.add("first-of-type-on-desktop")
               element.classList.remove("first-of-type")
            }else {
               //otherwise set as first of type
               element.classList.add("first-of-type")
               element.classList.remove("first-of-type-on-desktop")
            }
            type = child.dataset.background
         } else {
            element.classList.add("first-of-type")
            type = "";
         }
      
   }
});
}

/* Function which keep elements squared. */
Barracuda.toSquare = function(){
   document.querySelectorAll(".square").forEach((element) => {
   var width = element.offsetWidth;
   /* console.log("square: ",element, "width: ",width) */
   element.style.height = width + "px";
   })
}

/* Functions which define css variable for announcement bar */
Barracuda.initAddHeight = function(){
   let root = document.documentElement;
   let el = document.querySelector(".announcement-bar");
   if(el){
      var addHeight = el.offsetHeight ? el.offsetHeight : 0;
      root.style.setProperty('--announcement-bar-height', addHeight + "px");
   }
   let header = document.querySelector("#header>.header");
   if(header){
      var headerHeight = header.offsetHeight? header.offsetHeight : 0;
      root.style.setProperty('--header-height', headerHeight + "px");
   }
}

Barracuda.setScrollBarWidth = function(){
   if(!document.querySelector(".topbar.visible")){
      /* console.log("ScrollbarWidth: set to: ",`${window.innerWidth - document.body.clientWidth}px`) */
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      if(scrollbarWidth < 60)
      document.body.style.setProperty(
         "--scrollbar-width",
         scrollbarWidth + "px"
      );
   }
}

/* Inicialization for barracuda functions */
Barracuda.init = function(){
   Barracuda.reInit();
      window.addEventListener("resize", ()=>{
         Barracuda.toSquare();
         Barracuda.setScrollBarWidth();
         Barracuda.initAddHeight();
      }); 
   if(Barracuda.elements.lazyVideos.length>0){
      Barracuda.elements.lazyVideosListener = window.addEventListener("scroll", Barracuda.checkVideos, {passive: true});
      setTimeout(Barracuda.checkVideos, 3000);
   }
   if(Barracuda.elements.lazyMaps.length>0){
      Barracuda.elements.lazyMapsListener = window.addEventListener("scroll", Barracuda.checkMaps, {passive: true});
      setTimeout(Barracuda.checkMaps, 3000);
   }
}
/* ReInit after Shopify Theme editor changes something  */
Barracuda.reInit = function(){
   Barracuda.cookieSection();
   Barracuda.initCollapsible();
   Barracuda.loadSection();
   Barracuda.loadPage();
   Barracuda.sectionPaddingForBackgroundsTwo();
   Barracuda.textareaAutoresize(); 
   Barracuda.toSquare();
   Barracuda.initAddHeight();
   Barracuda.checkVideos();
   Barracuda.checkMaps();
   Barracuda.templateOverlay();
}

/* System for Dynamic colors when overlay inverted elements. */
class BarracudaOverlapping{
   constructor(){
      this.setOverlaping();
      window.addEventListener("scroll", this.setOverlaping.bind(this));
      window.addEventListener("resize", this.setOverlaping.bind(this));
   }
   setOverlaping(){
      document.querySelectorAll(".sidebar .icon svg,.change-color-overlap").forEach(el=>{
            var overlap = false;
            document.querySelectorAll(".use-inverted-colors.full-width, .control-inverted").forEach(background=>{
               if(this.isOverlapping(el, background))
                  overlap = true;
               });
               if(overlap) 
                        el.classList.add("use-inverted-colors");
               else
                        el.classList.remove("use-inverted-colors");
      });
      document.querySelectorAll("#header.can-be-transparent").forEach(el => {
         var overlap = false;
         document.querySelectorAll(".header-can-overlap").forEach(background => {
            if (this.isOverlapping(el, background)) {
               overlap = true;
            }
         })
         if (overlap) {
            el.classList.add("should-be-transparent")
         }
         else {
            el.classList.remove("should-be-transparent")
         }
      })
   }
   check(){
      this.setOverlaping();
   }
   isOverlapping(e1, e2){
      if (e1.length && e1.length > 1) {
      e1 = e1[0];
      }
      if (e2.length && e2.length > 1){
      e2 = e2[0];
      }
      const rect1 = e1 instanceof Element ? e1.getBoundingClientRect() : false;
      const rect2 = e2 instanceof Element ? e2.getBoundingClientRect() : false;
      
      let overlap = false;
   
      if (rect1 && rect2) {
      overlap = !(
         rect1.right < rect2.left || 
         rect1.left > rect2.right || 
         rect1.bottom < rect2.top || 
         rect1.top > rect2.bottom
      );
      return overlap;  
      }
   
      console.warn('Not valid HTMLElement object');
      return overlap;
   }
}


class BarracudaAnimatedMenu{
   constructor(){
   this.debug = true;
   this.hidden = false;
   this.menu = document.querySelector(".main-menu");
   this.linksInMenu = this.menu? this.menu.querySelectorAll("ul:not(.child):not(.grandchild)>li"): false;
   
   }
   hideMenuLinks(){
      if(!this.hidden){
         this.hidden = true;
         this.linksInMenu.forEach(function (link) {
            link.dataset.height = link.clientHeight + 1;
            link.style.maxHeight = 0 + "px";
            link.style.overflow = "hidden";
            link.style.transition = "max-height 0.55s cubic-bezier(0.32, 0.08, 0.24, 1)";
         })
      }
   }
   showMenuLinks(i = 0){
      if(i == 0) this.hidden = false;
      var link = this.linksInMenu[i];
      if(link){
         link.style.maxHeight = link.dataset.height + "px";
         setTimeout((function (){this.removeSettings(link)}).bind(this), 1000);
         setTimeout((function (){this.showMenuLinks(++i)}).bind(this), 6);
      }
   }
   removeSettings(link){
      if(link){
         link.style.transition = "";
         link.style.maxHeight = "";
         link.style.overflow = "";
      }
   }
}

class BarracudaRichMedia{
   constructor(element){
      this.element = element;
      this.mediaid = element.dataset.mediaid;
      this.template = document.getElementById("templateid-"+this.mediaid);
      this.container = document.getElementById("containerid-"+this.mediaid);
      this.cover = this.element;
      this.media = null
      this.type = null

      if(this.template && this.container){
         /* Add listener to show button */
         console.log(this.element.parentElement)
         this.element.parentElement.querySelector("button.media-icon").addEventListener("click",this.show.bind(this), false);
      }else{
         console.error("BarracudaRichMedia: Rich media not found - container or template", this.template, this.container)
      }
   }
   getType(){
      if(this.container.querySelector(".js-youtube")){
         this.media = this.container.querySelector(".js-youtube");
         this.type = "youtube";
      }
      if(this.container.querySelector(".js-vimeo")){
         this.media = this.container.querySelector(".js-vimeo");
         this.type = "vimeo";
      }
      if(this.container.querySelector("video")){
         this.media = this.container.querySelector("video");
         this.type = "video";
      }
   }

   play(){
      console.log("BarracudaRichMedia: play", this.mediaid);
      switch(this.type){
         case "youtube":
            this.media.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
            break;
         case "vimeo":
            this.media.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
            break;
         case "video":
            this.media.play();
            break;
      }
   }
   pause(){
      console.log("BarracudaRichMedia: pause", this.mediaid);
      switch(this.type){
         case "youtube":
            this.media.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            break;
         case "vimeo":
            this.media.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
            break;
         case "video":
            this.media.pause();
            break;
      }
   }
   hide(){
      console.log("BarracudaRichMedia: hide", this.mediaid);
      this.container.innerHTML = "";
      this.cover.classList.remove("hidden");
      this.container.classList.add("hidden");
   }
   show(){
      console.log("BarracudaRichMedia: show", this.mediaid);
      this.cover.classList.add("hidden");
      this.container.classList.remove("hidden");
      this.container.innerHTML = this.template.innerHTML;
      this.getType();

      this.stopOthers();
      this.play();
      setTimeout(this.play.bind(this),100);
   }
   stopOthers(){
      for (const [key, value] of Object.entries(Barracuda.elements.richMedia)) {
         if(key != this.mediaid)
            value.pause();
       }
   }
}

class ProductModel extends HTMLElement {
   constructor() {
     super();  
     Shopify.loadFeatures([
       {
         name: 'model-viewer-ui',
         version: '1.0',
         onLoad: this.setupModelViewerUI.bind(this),
       },
     ]);
   }
   setupModelViewerUI(errors) {
     if (errors) return;
     this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
   }
 }
customElements.define('product-model', ProductModel);
 

class BarracudaRender extends HTMLElement {
   constructor() {
      super();
      this.page = this.getAttribute("page");
      this.section = this.getAttribute("section");
      if (this.page && this.section) {
         this.getContent();
      }
   }
   getContent() {
      console.log(this.page)
      axios.get(this.page+"?sections="+this.section)
         .then(function (response) {
            console.log(response);
            console.log(this);
            if (response.data) {
               Object.keys(response.data).forEach(function (el) {
                  this.innerHTML += response.data[el]
               }.bind(this))
            }
         }.bind(this))
         .catch(function (error) {
             console.error(error);
         });
   }
}
customElements.define('barracuda-render', BarracudaRender);
 

window.addEventListener('DOMContentLoaded', (event) => {
   document.querySelector('body').classList.add('script');
});

class BarracudaProductGallery extends HTMLElement {
   constructor() {
      super();
      this.richMedia = []
      this.initialized = false;
      if (document.querySelector("body").classList.contains("script"))
         this.init()
      else
         window.addEventListener('DOMContentLoaded', this.init.bind(this));
   }
   init() {
      if(!this.initialized){
         this.initialized = true;
         //get current and all slides
         this.content = this.querySelector('.product-gallery-content');
         this.heightStyle = this.content.classList.contains("defined-height") ? (this.content.classList.contains("vh-product-gallery") ? 2 : 1) : false;
         this.thumbnails = this.querySelectorAll('.product-gallery-thumbnails>.thumbnail-media');
         this.thumbnails = this.thumbnails.length > 1 ? this.thumbnails : false;
         this.dots = this.querySelectorAll('.product-gallery-dots>.dot');
         this.slides = this.querySelectorAll('.product-media');
         if (this.querySelector('.product-media.current'))
            this.current = Array.from(this.slides).indexOf(this.querySelector('.product-media.current'))
         else {
            this.current = 0;
            this.slides[0].classList.add('current');
         }
         //if thumbnails on, select current
         if (this.thumbnails) this.thumbnailsGoto(this.thumbnails[this.current], this.current);
         //if dots on, select current
         if (this.dots) this.dotsGoto(this.current);
      
         //init height
         if(this.slides[this.current].querySelector("img")){
            this.slides[this.current].querySelector("img").addEventListener('load', ()=>{
               this.resize()
            })
         }
         this.resize();
         window.addEventListener('resize',this.resize.bind(this))
         
         //add Event listeners to controls
         if (this.slides.length > 1)
         {
            this.addAction(this.querySelector(".media-next"), this.next.bind(this))
            this.addAction(this.querySelector(".media-prev"), this.prev.bind(this))
         }
         this.addAction(this.querySelector(".media-zoom-in"), this.zoom.bind(this))
         this.addAction(this.querySelector(".media-zoom-out"), this.zoom.bind(this))
         if (this.thumbnails) {
            this.addAction(this.querySelector(".thumbnails-up"), this.thumbnailsGoto.bind(this, "up"))
            this.addAction(this.querySelector(".thumbnails-down"), this.thumbnailsGoto.bind(this, "down"))
         }
         if (this.dots) this.dots.forEach((dot, index) => {
            this.addAction(dot, this.goto.bind(this, index))
         })
         if (this.thumbnails) this.thumbnails.forEach((thumbnail, index) => {
            this.addAction(thumbnail, this.goto.bind(this, index))
         })
         this.content.querySelectorAll(".media-icon").forEach((btn) => {
            this.addAction(btn, this.mediaReplace.bind(this, btn))
         })
         this.addAction(this.querySelector(".media-close"), this.mediaClose.bind(this))
         //swipe
         if (typeof Swipe !== 'undefined') {
            new Swipe(this.content);
               this.content.addEventListener("swipe", this.swipe.bind(this));
         }
      }
   }
   addAction(item, fkc) {
      if (item) {
         item.addEventListener('click', (e) => {
            if(e.target.closest(":focus")) e.target.closest(":focus").blur()
            fkc()
         })
         item.addEventListener('keydown', (e) => {
            if (e.key == 'Space' || e.key == 'Enter') {
              item.click();
            }
         })
      }
   }
   swipe(e){
      if (e.detail && e.detail.direction)
         switch (e.detail.direction) {
            case "left":
               this.prev();
               break;
            case "right":
               this.next();
               break;
         }
   }
   next() {
      this.goto(this.current<(this.slides.length - 1)? this.current+1 : 0) 
   }
   prev() {
      this.goto(this.current > 0 ? this.current - 1 : this.slides.length - 1)
   }
   goto(target) {
      if (typeof target === 'string') {
         let targetEl = this.querySelector(target);
         target = Array.prototype.indexOf.call(this.slides, targetEl)
      }
      if (typeof target === 'number' && target >= 0 && !this.lock && target != this.current) {
         if (this.mediaOpen) {
            this.mediaClose();
            this.pauseMedia();
         }
         this.lock = true
         if (this.thumbnails) this.thumbnailsGoto(this.thumbnails[target], target);
         if (this.dots) this.dotsGoto(target);
         this.anime = anime.timeline({
            duration: 300,
            easing: 'linear'
         }).add({
            targets: this.slides[target],
            opacity: [0, 1]
         }, 0).add({
            targets: this.slides[this.current],
            opacity: [1, 0],
            complete: () => {
               this.slides[this.current].classList.remove('current');
               this.current = target;
               this.slides[this.current].classList.add('current');
               this.lock = false;
            }
         }, 0).add(!this.fullscreen? {
            targets: this.content,
            height: [this.content.offsetHeight,this.slides[target].scrollHeight + "px"],
         } : {}, 0).add((this.thumbnails && !this.fullscreen)? {
            targets: this.content.querySelector(".product-gallery-thumbnails"),
            maxHeight: [this.content.querySelector(".product-gallery-thumbnails").style.maxHeight,(Math.floor((this.slides[target].scrollHeight - 48 - 116) / 116) * 116) + "px" ]
         } : {}, 0)
      }
   }
   zoom() {
      if (this.fullscreen) {
         window.removeEventListener('keydown',this.fullscreenListener);
         this.content.classList.remove("fullscreen");
         anime({
            targets: this.content.querySelector(".thumbnails-navigation"),
            easing: "easeInOutSine",
            duration: 200,
            marginLeft: "0px",
            marginTop: "0px"
         })
         anime({
            targets: this.content.querySelector(".product-media.type-image.current"),
            easing: "easeInOutSine",
            duration: 200,
            height: [(el) => {
               if (parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                  return document.documentElement.clientHeight + "px";
               else
                  return document.documentElement.clientWidth / parseFloat(el.querySelector("img").dataset.ratio) + "px"
            }, ((el) => {
               if (this.content.classList.contains("adapt"))
                  return this.preZoom.width * parseFloat(el.querySelector("img").dataset.ratio)
               else
                  return this.preZoom.height
            }).bind(this)],
            width: [(el) => {
               if (parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                  return (parseFloat(el.querySelector("img").dataset.ratio) * document.documentElement.clientHeight) + "px"
               else
                  return document.documentElement.clientWidth + "px"
            }, this.preZoom.width],
            marginLeft: [(el) => {
               if (parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                  return (document.documentElement.clientWidth - (parseFloat(el.querySelector("img").dataset.ratio) * document.documentElement.clientHeight)) / 2
               else
                  return 0
            }, 0],
            marginTop: [(el) => {
               if ( parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                  return 0
               else
                  return ((document.documentElement.clientHeight - (document.documentElement.clientWidth / parseFloat(el.querySelector("img").dataset.ratio))) / 2) + "px"
            }, 0],
            complete: (animation) => {
               let el = animation.animatables[0].target
               el.style.removeProperty("margin-left");
               el.style.removeProperty("margin-top");
               el.style.removeProperty("height")
               el.style.removeProperty("width")
            }
         })
         anime({
            targets: this.content,
            easing: "easeInOutSine",
            duration: 200,
            width: [ this.content.offsetWidth + "px", this.preZoom.width], 
            height: [ this.content.offsetHeight + "px", this.preZoom.height], 
            left: this.preZoom.left, 
            top: this.preZoom.top,
            complete: (() => {
               this.content.style.removeProperty("position");
               this.content.style.removeProperty("width");
               this.content.style.removeProperty("height");
               this.content.style.removeProperty("left");
               this.content.style.removeProperty("top");
               this.content.style.removeProperty("z-index");
               this.content.parentElement.parentElement.style.removeProperty("min-height");
               this.content.classList.remove("fullscreen");
               if(this.heightStyle == 2) this.content.classList.add("vh-product-gallery");
               this.resize()
               unlockBodyPosition();
            }).bind(this)
         })
        
      } else {
         this.preZoom = {
            width: this.content.offsetWidth + "px",
            height: this.content.offsetHeight + "px",
            top: this.content.getBoundingClientRect().top + "px",
            left: this.content.getBoundingClientRect().left + "px"
         }
         this.content.style.position = "fixed";
         this.content.style.width = this.preZoom.width;
         this.content.style.height = this.preZoom.height;
         this.content.style.top = this.preZoom.top;
         this.content.style.left = this.preZoom.left;
         this.content.style.zIndex = 9;
         this.content.parentElement.parentElement.style.minHeight = this.preZoom.height;
         
         anime({
            targets: this.content.querySelector(".thumbnails-navigation"),
            easing: "easeInOutSine",
            duration: 200,
            marginLeft: "48px",
            marginTop: "48px"
         })
         anime({
            targets: this.content.querySelector(".product-media.type-image.current"),
            easing: "easeInOutSine",
            duration: 200,
            height: ((el) => {
               console.log(parseFloat(el.querySelector("img").dataset.ratio), document.documentElement.clientWidth / document.documentElement.clientHeight)
               if (parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
               {   console.log("1");
                  return document.documentElement.clientHeight + "px"
               }else{
                  console.log("2");
                  return document.documentElement.clientWidth / parseFloat(el.querySelector("img").dataset.ratio) + "px"}
            }).bind(this),
            width: (el) => { 
               if (parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                  return (parseFloat(el.querySelector("img").dataset.ratio) * document.documentElement.clientHeight)+"px"
               else
                  return document.documentElement.clientWidth + "px"
            },
            marginLeft: [0, (el) => { 
               if ( parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                  return ((document.documentElement.clientWidth - (parseFloat(el.querySelector("img").dataset.ratio) * document.documentElement.clientHeight)) / 2) + "px"
               else
                  return 0
            }],
            marginTop: [0, (el) => {
               if ( parseFloat(el.querySelector("img").dataset.ratio) <= (document.documentElement.clientWidth / document.documentElement.clientHeight))
                  return 0
               else
                  return ((document.documentElement.clientHeight - (document.documentElement.clientWidth / parseFloat(el.querySelector("img").dataset.ratio))) / 2) + "px"
            }],
            complete: (animation) => {
               console.log(animation);
               let el = animation.animatables[0].target
               el.style.removeProperty("margin-left");
               el.style.removeProperty("margin-top");
               el.style.removeProperty("height")
               el.style.removeProperty("width")
            }
         })
         anime({
            targets: this.content,
            easing: "easeInOutSine",
            duration: 200,
            left: 0,
            top: 0,
            height: document.documentElement.clientHeight + "px",
            width: document.documentElement.clientWidth + "px",
            complete: (() => {
               this.content.classList.add('fullscreen');
            }).bind(this)
         }) 
            this.fullscreenListener = ((e) => {
               switch (e.key) {
                  case "Escape":
                     this.zoom()
                     break;
                  case "ArrowRight":
                     this.next()
                     break;
                  case "ArrowLeft":
                     this.prev()
                     break;
               }
            }).bind(this);
            window.addEventListener('keydown', this.fullscreenListener);
            if(this.heightStyle == 2) this.content.classList.remove("vh-product-gallery");
         if (this.thumbnails) {
            this.content.querySelector(".product-gallery-thumbnails").style.maxHeight = "calc(" + Math.floor((document.documentElement.clientHeight - 48 - 116) / 116) + " * 116px)";
            if ((Math.floor((document.documentElement.clientHeight - 48 - 116) / 116) * 116) >= this.querySelector(".product-gallery-thumbnails").scrollHeight) {
               this.querySelector(".thumbnails-controls").classList.add("hidden");
            } else{
               this.querySelector(".thumbnails-controls").classList.remove("hidden");
            }
         }
            lockBodyPosition();
            
      }
      this.fullscreen = !this.fullscreen;
   }
   thumbnailsGoto(target, position = null) {
      let thumbnailsGallery = this.querySelector(".product-gallery-thumbnails");
      switch (typeof target){ 
         case "string":
            target = target == "up" ? -1 * thumbnailsGallery.offsetHeight:  thumbnailsGallery.offsetHeight
            if (target < 0)
               target = thumbnailsGallery.scrollTop == 0 ? thumbnailsGallery.scrollHeight : thumbnailsGallery.scrollTop + target
            else if (target > 0)
               target = (thumbnailsGallery.scrollTop == (thumbnailsGallery.scrollHeight - thumbnailsGallery.offsetHeight)) ? 0 : thumbnailsGallery.scrollTop + target
            break;
         case "object":
            target = target.offsetTop;
            this.thumbnails.forEach((thumbnail, index) => { if (index != position) thumbnail.classList.remove("current"); else thumbnail.classList.add("current")})
            break;
      }
      anime({
         targets: thumbnailsGallery,
         scrollTop: target,
         duration: 1000,
         easing: "easeOutCubic"
      });
   }
   dotsGoto(target) {
      this.dots.forEach((dot, index)=>{
         if(index != target) dot.classList.remove("current");
         else dot.classList.add("current");
      })

      function dotsVisibility(from = null, to = null){
         if(this.dots.length>0){
            this.dots.forEach(dot=>{
               dot.classList.remove("end");
               dot.classList.add("visible");
            })
            if(from){
               for (let i = 0; i < from; i++) { if(this.dots[i]) this.dots[i].classList.remove("visible");}
               if(this.dots[from]) this.dots[from].classList.add("end");
            }
            if(to){
               for (let i = to; i < this.dots.length; i++){ if(this.dots[i]) this.dots[i].classList.remove("visible");}
               if(this.dots[(to-1)] && (to != this.dots.length)) this.dots[(to-1)].classList.add("end");
            }
         }
      }
      dotsVisibility = dotsVisibility.bind(this);
         
      var visibleDots = 5; // count of visible dots
      var dotsCount = this.dots.length;
      if(dotsCount <= visibleDots)
         dotsVisibility();
      else if(target < 3)
         dotsVisibility(null,visibleDots);
      else if((target + 3)> dotsCount)
         dotsVisibility((dotsCount-visibleDots),null);
      else
         dotsVisibility((target - 2),(target + 3))
      
   }
   mediaReplace(btn) {
      this.mediaOpen = true;
      let media = btn.parentElement.querySelector("template").content.firstElementChild.cloneNode(true)
      this.richMedia[this.current] = media.firstElementChild;
      btn.parentElement.appendChild(media);
      media.focus();
      btn.parentElement.querySelector("button").classList.add("hidden");
      this.content.querySelector(".thumbnails-navigation").classList.add("hidden");
      this.content.querySelectorAll(".media-zoom").forEach(el=>{el.classList.add("hidden")});
      this.content.querySelector(".media-close").classList.remove("hidden");
   }
   mediaClose() {
      this.mediaOpen = false;
      this.slides[this.current].querySelector(".product-media-frame").remove();
      this.slides[this.current].querySelector("button").classList.remove("hidden");
      this.content.querySelectorAll(".media-zoom").forEach(el=>{el.classList.remove("hidden")});
      this.content.querySelector(".thumbnails-navigation").classList.remove("hidden");
      this.content.querySelector(".media-close").classList.add("hidden");
      this.richMedia.splice(this.current, 1);
   }
   pauseMedia(){
      this.richMedia.forEach(el => {
         if (el) {
           if(el.classList.contains("js-youtube"))
               el.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
           else if(el.classList.contains("js-vimeo"))
               el.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
           else if(el.classList.contains("video"))
               el.pause();
         }
       })
   }
   resize() {
      if (this.fullscreen) {
         this.content.style.height = document.documentElement.clientHeight + "px"
         this.content.style.width = document.documentElement.clientWidth + "px"
         if (this.thumbnails) {
            this.content.querySelector(".product-gallery-thumbnails").style.maxHeight = "calc("+ Math.floor((document.documentElement.clientHeight - 48 - 116) / 116) +" * 116px)";
            if ((Math.floor((document.documentElement.clientHeight - 48 - 116) / 116) * 116) >= this.querySelector(".product-gallery-thumbnails").scrollHeight) {
               this.querySelector(".thumbnails-controls").classList.add("hidden");
            } else{
               this.querySelector(".thumbnails-controls").classList.remove("hidden");
            }
         }
      } else {
         if (this.heightStyle < 1)
            this.content.style.height = this.slides[this.current].scrollHeight + "px"
         else if (this.heightStyle == 2)
            this.content.style.removeProperty("height")
         if (this.thumbnails) {
            this.content.querySelector(".product-gallery-thumbnails").style.maxHeight = "calc(" + Math.floor((this.slides[this.current].scrollHeight - 48 - 116) / 116) + " * 116px)";
            if ((Math.floor((this.slides[this.current].scrollHeight - 48 - 116) / 116) * 116) >= this.querySelector(".product-gallery-thumbnails").scrollHeight) {
               this.querySelector(".thumbnails-controls").classList.add("hidden");
            }
         }
      }
   }
}
customElements.define('barracuda-product-gallery', BarracudaProductGallery);

class BarracudaAnnouncementBar extends HTMLElement {
   constructor() {
      super();
      this.initialized = false;
      if (document.querySelector("body").classList.contains("script"))
         this.init()
      else
         window.addEventListener('DOMContentLoaded', this.init.bind(this));
   }
   init() {
      if (!this.initialized) {
         this.initialized = true;
         this.time = this.getAttribute('time') ? parseInt(this.getAttribute('time')) * 1000 : 1200;
         this.current = 0;
         this.elements = this.querySelectorAll('.announcement');
         this.autoplay = (this.time && this.elements.length > 1)? this.time : false;
         this.resize();
         let closer = this.querySelector(".hide-by-cookie-toggle");
         if (closer) closer.addEventListener('click', this.close.bind(this));
         window.addEventListener("resize", this.resize.bind(this), false);
         if(this.elements.length > 1) this.timeout = setTimeout(this.setNext.bind(this,this.current+1), this.time);
      }
   }
   close() {
      this.autoplay = false;
   }
   resize() {
      this.height = 0
      this.elements.forEach(el => {
         if(el.firstElementChild.scrollHeight > this.height) this.height = el.firstElementChild.scrollHeight;
      })
      if (this.height > 48) this.querySelector('.announcement-bar-content').style.height = this.height + "px"
      else this.querySelector('.announcement-bar-content').style.height = 48 + "px"
   }
   setNext(next = (this.current + 1), pause = false) {
      if (pause) clearTimeout(this.timeout);
      if(next != this.current){
         if (next >= this.elements.length) next = 0;
         this.elements[next].classList.add("current");
         this.elements[this.current].classList.remove("current")
         this.current = next;
      }
      if (!pause && this.autoplay) this.timeout = setTimeout(this.setNext.bind(this, this.current + 1), this.time);
   }
}
customElements.define('barracuda-announcement-bar', BarracudaAnnouncementBar);

class BarracudaSubHeader extends HTMLElement {
   constructor() {
      super();
      this.initialized = false;
      if (document.querySelector("body").classList.contains("script"))
         this.init()
      else
         window.addEventListener('DOMContentLoaded', this.init.bind(this));
   }
   init() {
      if (!this.initialized) {
         this.initialized = true;
         this.content = this.firstElementChild;
         this.height = this.content.scrollHeight;
         this.opener = this.closest(".sub-header-opener");
         this.opener.addEventListener('mouseenter', this.mouseEnter.bind(this));
         this.opener.addEventListener('mouseleave', this.mouseLeave.bind(this));
         setTimeout(() => {
            this.content.querySelectorAll("img").forEach(el => {
               el.removeAttribute("loading");
               console.log("Removed loading");
            })
         },1000)
      }
   }
   mouseEnter() {
      let header = this.closest("#header")
      if(header.classList.contains("should-be-transparent")){
         header.classList.remove("should-be-transparent")
         header.classList.remove("can-be-transparent")
         header.classList.add("cant-be-transparent")
      }
   }
   mouseLeave() {
      let header = this.closest("#header")
      if(header.classList.contains("cant-be-transparent")){
         header.classList.remove("cant-be-transparent")
         header.classList.add("can-be-transparent")
         if(Barracuda.elements.Overlapping)
            Barracuda.elements.Overlapping.check();
      }
   }
}
customElements.define('barracuda-sub-header', BarracudaSubHeader);

class BarracudaCarousel extends HTMLElement {
   constructor() {
      super();
      this.initialized = false;
      if (document.querySelector("body").classList.contains("script"))
         this.init()
      else
         window.addEventListener('DOMContentLoaded', this.init.bind(this));
   }
   init() {
      if (!this.initialized) {
         this.initialized = true;
         console.log(this)
         this.content = this.querySelector(".carousel-grid")
         this.dots = this.querySelectorAll(".barracuda-dot")
         this.leftArrow = this.querySelector(".prev")
         this.rightArrow = this.querySelector(".next")

         this.leftArrow.addEventListener("click", this.prev.bind(this));
         this.rightArrow.addEventListener("click", this.next.bind(this));
         this.dots.forEach((el)=>{el.addEventListener("click", this.goTo.bind(this,el));});
         this.currentDot = this.dots[0];
         if(this.currentDot) this.currentDot.classList.add("current"); 
         this.resize();
         window.addEventListener("resize", this.resize.bind(this));
         this.content.addEventListener("scroll", this.updateDots.bind(this))
         /* this.content.addEventListener("mousedown", this.mouseDown.bind(this)); */
      }
   }
   mouseDown(event) {
      if (typeof this.mouseDrag !== "object") {
         this.mouseDrag = {
            pos: this.content.scrollLeft + event.clientX,
            mousemove: this.mouseMove.bind(this),
            mouseup: this.mouseUp.bind(this)
         }

         this.content.addEventListener("mousemove", this.mouseDrag.mousemove)
         this.content.addEventListener("mouseup", this.mouseDrag.mouseup)
         this.content.addEventListener("mouseleave", this.mouseDrag.mouseup)
      }
   }
   mouseMove(event) {
      this.content.scrollLeft = (this.mouseDrag.pos - event.clientX);
      this.content.style.cursor = 'grabbing';
      this.content.style.userSelect = 'none';
      this.content.style.WebkitUserSelect = "none";
   }
   mouseUp() {
      this.content.removeEventListener("mousemove", this.mouseDrag.mousemove);
      this.content.removeEventListener("mouseup",this.mouseDrag.mouseup);
      this.content.removeEventListener("mouseleave",this.mouseDrag.mouseup);

      this.content.style.cursor = 'grab';
      this.content.style.removeProperty('user-select');
      this.content.style.removeProperty('-webkit-user-select')
      setTimeout(this.updateDots.bind(this), 10)
      this.mouseDrag = false;
   }
   goTo(dot) {
      if (dot.dataset.i != this.currentDot.dataset.i){
         anime({
            targets: this.content, 
            scrollLeft: this.content.querySelector(".block:nth-child("+dot.dataset.i+")").offsetLeft,
            easing: "easeInOutCubic",
            duration: Math.abs(this.content.querySelector(".block:nth-child("+dot.dataset.i+")").offsetLeft - this.content.querySelector(".block:nth-child("+this.currentDot.dataset.i+")").offsetLeft) * 0.75,
            complete: this.updateDots.bind(this)
         })  
      }
   }
   next() {
      console.log("next");
      let space = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--grid-gutter'));
      if (!space) {
         space = getComputedStyle(document.documentElement).getPropertyValue('--grid-gutter');
         let calc = function (x) { return x; }
         space = eval(space.replaceAll("px", "").replace("max", "Math.max"));
      }
      anime({
         targets: this.content,
         scrollLeft: () => {
            if (this.content.scrollLeft == this.content.scrollWidth - (this.content.offsetWidth))
               return 0
            else
               return this.content.scrollLeft + (this.content.offsetWidth + space) 
         },
         easing: "easeInOutCubic",
         duration: (this.content.offsetWidth + space) * 0.75,
         complete: this.updateDots.bind(this)
      })  
   }
   prev() {
      console.log("prev");
      let space = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--grid-gutter'));
      if (!space) {
         space = getComputedStyle(document.documentElement).getPropertyValue('--grid-gutter');
         let calc = function (x) { return x; }
         space = eval(space.replaceAll("px", "").replace("max", "Math.max"));
      }
      anime({
         targets: this.content,
         scrollLeft: () => {
            if (this.content.scrollLeft == 0) {
               console.log()
               return this.content.scrollWidth - (this.content.offsetWidth) 
            }else
               return this.content.scrollLeft - (this.content.offsetWidth + space)
         },
         easing: "easeInOutCubic",
         duration: (this.content.offsetWidth + space) * 0.75,
         complete: this.updateDots.bind(this)
      })
   }
   resize() {
      const columns = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--grid-columns'));
      this.dots.forEach((el, index) => {
         if (index % columns == 0) {
            el.classList.add("active")
         } else{
            el.classList.remove("active")
         }  
      })
      this.updateDots();
   }
   updateDots() {
      let space = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--grid-gutter'));
      if (!space) {
         space = getComputedStyle(document.documentElement).getPropertyValue('--grid-gutter');
         let calc = function (x) { return x; }
         space = eval(space.replaceAll("px", "").replace("max", "Math.max"));
      }
      let target = parseInt(Math.ceil((this.content.scrollLeft / (this.content.offsetWidth + space))))
      let currentDot = this.querySelectorAll(".barracuda-dot.active")[target]
      if (currentDot) {
         if (currentDot != this.currentDot) {
            this.currentDot.classList.remove("current");
            this.currentDot = currentDot;
            this.currentDot.classList.add("current"); 
         }
      }

      function dotsVisibility(dots, from = null, to = null){
         if (dots.length > 0) {
            console.log("dots lenght: " + dots.length);
            dots.forEach(dot=>{
               dot.classList.remove("end");
               dot.classList.add("visible");
            })
            if(from){
               for (let i = 0; i < from; i++) { if(dots[i]) dots[i].classList.remove("visible");}
               if(dots[from]) dots[from].classList.add("end");
            }
            if(to){
               for (let i = to; i < dots.length; i++){ if(dots[i]) dots[i].classList.remove("visible");}
               if(dots[(to-1)] && (to != dots.length)) dots[(to-1)].classList.add("end");
            }
         }
      }
      dotsVisibility = dotsVisibility.bind(this);
         
      let dots = this.querySelectorAll(".barracuda-dot.active")
      var visibleDots = 5; // count of visible dots
      var dotsCount = dots.length;
      console.log("dotsCount: " + dotsCount, "target: "+ target)
      if(dotsCount <= visibleDots)
         dotsVisibility(dots);
      else if(target < 3)
         dotsVisibility(dots,null,visibleDots);
      else if((target + 3)> dotsCount)
         dotsVisibility(dots,(dotsCount-visibleDots),null);
      else
         dotsVisibility(dots,(target - 2),(target + 3))
   }
}
customElements.define('barracuda-carousel', BarracudaCarousel);

class BarracudaPopupOpener extends HTMLElement {
   constructor() {
      super();
      this.initialized = false;
      if (document.querySelector("body").classList.contains("script"))
         this.init()
      else
         window.addEventListener('DOMContentLoaded', this.init.bind(this));
   }
   init() {
      if (!this.initialized) {
         this.initialized = true;
         this.url = this.getAttribute("url");
         this.sectionSelector = this.getAttribute("section");
         if(this.url && this.sectionSelector) this.querySelector("a").addEventListener("click", this.open.bind(this));
      }
   }
   open(e) {
      prevent(e);
      axios.get(this.url)
         .then(function (response) {
            if (response.data) {
               var x = document.createElement("html");
               x.innerHTML = response.data;
               var source = x.querySelector(this.sectionSelector);
               if (source){
                  let target = document.querySelector(".overlay-content");
      
                  var currentContent = document.querySelector(".overlay-content-content>form, .overlay-content-content>div");
                  if (currentContent && currentContent.dataset.source && document.querySelector("#" + currentContent.dataset.source))
                     document.querySelector("#" + currentContent.dataset.source).appendChild(currentContent);

                  target.innerHTML = "";

                  var closer = document.createElement("a");
                  closer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
                  closer.classList.add("icon", "icon-x", "overlay-closer");
                     
                  var content = document.createElement("div");
                  content.appendChild(source)
                  content.classList.add("overlay-content-content", "scroll-inside");
                  if (source.dataset.type) content.classList.add(...source.dataset.type.split(" "));
                     
                  target.appendChild(closer);
                  target.appendChild(content);

                  if (content.querySelector(".map")) {
                     setTimeout(function () {
                        Barracuda.loadMapsScript(content);
                     }, 200);
                  }

                  Barracuda.init();
                  Barracuda.elements.init();
                  target.classList.remove("loading");
                  lockBodyPosition();
                  document.querySelector("body").classList.add("show-overlay");
               }
            }
         }.bind(this))
         .catch(function (error) {
            console.warn(error);
         });
         return false;
   }
}
customElements.define('barracuda-popup-opener', BarracudaPopupOpener);

class BarracudaTabs extends HTMLElement {
   constructor() {
      super();
      this.initialized = false;
      if (document.querySelector("body").classList.contains("script"))
         this.init()
      else
         window.addEventListener('DOMContentLoaded', this.init.bind(this));
   }
   init() {
      if (!this.initialized) {
         this.initialized = true;
         this.content = this.querySelector(".tabs-content")
         this.tabOpeners = this.querySelectorAll(".tab-opener");
         this.tabContents = this.querySelectorAll(".tab-content");
         this.current = parseInt(this.querySelector(".tab-opener.active").dataset.i);
         this.tabOpeners.forEach((el, key) => {
            el.addEventListener("click",this.showTab.bind(this, key));
         })
      }
   }
   showTab(i, animation = true) {
      console.log("Currrent: ", this.current, "Next: ", i);
      this.tabOpeners.forEach((el, key) => { if (i != key) el.classList.remove("active") })
      this.tabOpeners[i].classList.add("active");

      if(animation){
         anime.timeline({
            duration: 300,
            easing: "linear"
         }).add({
            targets: this.tabContents[this.current],
            opacity: [1, 0],
            maxHeight: [this.tabContents[this.current].scrollHeight + "px", this.tabContents[i].scrollHeight + "px"],
            before: function () {
               this.tabContents[this.current].style.width = this.tabContents[this.current].offsetWidth + "px";
               this.tabContents[this.current].style.position = "absolute";
               this.tabContents[this.current].style.overflow = "hidden";
            }.bind(this),
            complete: function () {
               this.tabContents[this.current].classList.remove("active");
               this.tabContents[this.current].style.removeProperty("position");
               this.tabContents[this.current].style.removeProperty("width");
               this.tabContents[this.current].style.removeProperty("max-height");
               this.tabContents[this.current].style.removeProperty("overflow");
            }.bind(this)
         },0).add({
            targets: this.content,
            height: [this.tabContents[this.current].scrollHeight + "px", this.tabContents[i].scrollHeight + "px"],
            complete: function () {
               this.content.style.removeProperty("height");
            }.bind(this)
         },0).add({
            targets: this.tabContents[i],
            opacity: [0, 1],
            maxHeight: [this.tabContents[this.current].scrollHeight + "px", this.tabContents[i].scrollHeight + "px"],
            complete: function () {
               this.tabContents[i].classList.add("active");
               this.tabContents[i].style.removeProperty("max-height");
               this.current = i;
            }.bind(this)
         }, 0);
      } else {
         this.tabContents.forEach((el, key) => { if(i != key) el.classList.remove("active") })
         this.tabContents[i].classList.add("active");
      }
   }
   customize(i) {
      this.showTab(i, false)
   } 
}
customElements.define('barracuda-tabs', BarracudaTabs);

class BarracudaProductRecommendations extends HTMLElement {
   constructor() {
      super();
      this.initialized = false;
      if (document.querySelector("body").classList.contains("script"))
         this.init()
      else
         window.addEventListener('DOMContentLoaded', this.init.bind(this));
   }
   init() {
      if (!this.initialized) {
         this.initialized = true;
         this.url = document.querySelector('body').dataset.url + this.dataset.url;
         this.hasContent = this.dataset.hasContent;
         if(this.hasContent == "false")
         axios.get(this.url)
            .then(function (response) {
               if (response.data) {
                  var x = document.createElement("html");
                  x.innerHTML = response.data;
                  let betterOne = x.querySelector("barracuda-product-recommendations");
                  if(betterOne.firstElementChild)
                     this.appendChild(betterOne.firstElementChild);
                  this.hasContent = true;
               }
            }.bind(this))
            .catch(function (error) {
               console.warn(error);
            });
      }
   } 
}
customElements.define('barracuda-product-recommendations', BarracudaProductRecommendations);

if (typeof BarracudaMarketSelector !== 'class'){
   class BarracudaMarketSelector extends HTMLElement {
       constructor() {
           super();
       
           this.initialized = false;
           if (document.querySelector("body").classList.contains("script"))
               this.init()
           else
               window.addEventListener('DOMContentLoaded', this.init.bind(this));
       }
       init() {
           if (!this.initialized) {
               this.initialized = true;
               this.select = this.querySelector("select");
               if(this.select.offsetWidth > 0) this.select.style.width = (this.select.offsetWidth + 7) + "px";
               else{
                   setTimeout(()=>{
                       if(this.select.offsetWidth > 0) this.select.style.width = (this.select.offsetWidth + 7) + "px";
                   }, 20);
               }
               this.select.addEventListener("mousedown", this.addOptions.bind(this));
               this.select.addEventListener("change", this.change.bind(this));
           }
       }
       addOptions() {
           this.querySelectorAll("select+select option").forEach((el)=>{
               this.select.appendChild(el);
           })
       }
       change(){
           this.closest("form").submit();
       }
   }
   customElements.define('barracuda-market-selector', BarracudaMarketSelector);
}